import { Controller } from "@hotwired/stimulus"

// Reveals .fh-reveal descendants (staggered via their own transition-delay)
// once the container scrolls into view. Used across the Fern homepage.
export default class extends Controller {
  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          this.reveal()
          this.observer.disconnect()
        })
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  reveal() {
    if (this.element.classList.contains("fh-reveal")) {
      this.element.classList.add("fh-reveal--in")
    }
    this.element.querySelectorAll(".fh-reveal").forEach((el) => {
      el.classList.add("fh-reveal--in")
    })
  }
}
